/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputEwActiveFrequency
 */
export interface OutputEwActiveFrequency {
    /**
     * 
     * @type {string}
     * @memberof OutputEwActiveFrequency
     */
    controlFrequency: string;
    /**
     * 
     * @type {string}
     * @memberof OutputEwActiveFrequency
     */
    craftName?: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof OutputEwActiveFrequency
     */
    freqs: Array<number>;
}

/**
 * Check if a given object implements the OutputEwActiveFrequency interface.
 */
export function instanceOfOutputEwActiveFrequency(value: object): boolean {
    if (!('controlFrequency' in value)) return false;
    if (!('freqs' in value)) return false;
    return true;
}

export function OutputEwActiveFrequencyFromJSON(json: any): OutputEwActiveFrequency {
    return OutputEwActiveFrequencyFromJSONTyped(json, false);
}

export function OutputEwActiveFrequencyFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputEwActiveFrequency {
    if (json == null) {
        return json;
    }
    return {
        
        'controlFrequency': json['controlFrequency'],
        'craftName': json['craftName'] == null ? undefined : json['craftName'],
        'freqs': json['freqs'],
    };
}

export function OutputEwActiveFrequencyToJSON(value?: OutputEwActiveFrequency | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'controlFrequency': value['controlFrequency'],
        'craftName': value['craftName'],
        'freqs': value['freqs'],
    };
}

